import { useTranslation } from 'react-i18next';
import type { IInvestigationReport } from '@apis/investigationReports';
import { getRecentCard } from './recentCardRegistry';
import styles from './RecentReportsRail.module.css';

interface IRecentReportsRailProps {
  items: IInvestigationReport[];
  siteId: string;
}

/**
 * Pure dispatcher. Owns the section frame (heading + empty state + list
 * scaffold) and delegates each row to a per-type RecentCard via the
 * registry. The shared visual chrome lives in `RecentCardShell`; per-type
 * cards only fill the meta-row middle slot.
 */
export function RecentReportsRail({ items, siteId }: IRecentReportsRailProps) {
  const { t } = useTranslation();
  return (
    <section className={styles.section} aria-label={t('analytics.recentTitle')}>
      <h2 className={styles.heading}>{t('analytics.recentTitle')}</h2>
      {items.length === 0 ? (
        <div className={styles.empty}>{t('analytics.recentEmpty')}</div>
      ) : (
        <ul className={styles.list}>
          {items.map((submission) => {
            const Card = getRecentCard(submission.investigationType);
            return (
              <li key={submission.reportId} className={styles.item}>
                <Card submission={submission} siteId={siteId} />
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
